// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".frm {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 10px;\n  height: 28px;\n  background: dodgerblue;\n}\n", ""]);
// Exports
module.exports = exports;
